import debug from 'debug';
import Engine from './engine';
import Message from './message';
import Behaviour from './static/behaviour';

const log = debug('ValidateForm');

class ValidateForm {
	/**
	 * @param {element} element
	 * @param {object} options
	 * @param {boolean} options.enableFieldEvents
	 * @param {boolean} options.enableMessages
	 */
	constructor(element, options = {}) {
		const { enableFieldEvents = true, enableMessages = true } = options;

		this.element = element;
		this.enableFieldEvents = enableFieldEvents;
		this.enableMessages = enableMessages;

		this.fieldEvent = this.fieldHandler.bind(this);

		this.initialize();
	}

	/**
	 * @param {element} formField
	 * @returns {Promise} [messages (success/failed), key]
	 */
	checkField(formField) {
		return this.engine.checkField(formField);
	}

	eventListeners() {
		if (this.enableFieldEvents === false) return;

		this.formFields.map(formField => {
			formField.addEventListener('blur', this.fieldEvent, false);
			formField.addEventListener('change', this.fieldEvent, false);
		});
	}

	fieldChanged(isValid) {
		Behaviour.dispatchEvent(Behaviour.eventKeys.fieldIsValid, {	isValid	});
	}

	async fieldHandler(event) {
		const formField = event.target;
		const fieldType = formField.type;

		switch (fieldType) {
			case 'checkbox':
			case 'email':
			case 'number':
			case 'tel':
			case 'text':
			case 'password':
			case 'textarea':
				const isValid = await this.validateField(formField);
				this.fieldChanged(isValid);
				break;
		}
	}

	initialize() {
		log(`initialize() - events: ${this.enableFieldEvents} - messages: ${this.enableMessages}`, this.element, );

		const formFields = this.element.querySelectorAll('[data-validate]'); 
		this.formFields = [...formFields];
		
		this.message = new Message();
		this.engine = new Engine(this.element, this.formFields);

		this.message.enableMessages(this.enableMessages);

		this.eventListeners();
	}

	/**
	 * @param {element} formField 
	 * @param {object} status 
	 * @returns {boolean}
	 */
	showMessage(formField, status) {
		const key = formField.getAttribute('data-validate');

		if (typeof status.messages[status.key] === 'object') {
			this.message.showErrorMessage(formField, status.messages[status.key]);
			return false;
		} else if (typeof status.messages[status.key] === 'string') {
			this.message.showValidMessage(formField);
		} else {
			log('showMessage() - not string nor object - typeof', typeof status.messages[status.key]);
			this.message.showValidMessage(formField);
		}

		return true;
	}

	/**
	 * @param {element} formField
	 * @returns {Promise} isValid
	 */
	async validateField(formField) {
		return new Promise (async (resolve, reject) => {
			const status = await this.checkField(formField);
			const isValid = this.showMessage(formField, status);

			resolve(isValid);
		});
	}

	/**
	 * @returns {Promise} valid
	 */
	async validateAllFields() {
		return new Promise (async (resolve, reject) => {
			let valid = true;
			const promises = [];
	
			this.formFields.map(formField => {
				const promise = this.validateField(formField);
				promises.push(promise);
			});
	
			const isValids = await Promise.all(promises);

			isValids.forEach(isValid => {
				if (isValid === false) {
					valid = false;
				}
			});

			resolve(valid);
		});
	}
}

export default ValidateForm;
